import React from 'react';
import { Hotel, Building2, ShoppingBag, GraduationCap } from 'lucide-react';

const IndustriesSection = () => {
  const industries = [
    {
      icon: <Hotel size={48} />,
      title: 'Hospitality',
      description: 'Streamlining operations, compliance, and customer experiences in hotels, restaurants, and entertainment venues with intelligent automation.'
    },
    {
      icon: <Building2 size={48} />,
      title: 'Commercial Real Estate',
      description: 'Revolutionizing space leasing, property management, and tenant relations through smart matching and analytics platforms.'
    },
    {
      icon: <ShoppingBag size={48} />,
      title: 'Retail & Entertainment',
      description: 'Enhancing customer engagement, operational efficiency, and venue management with comprehensive digital solutions.'
    },
    {
      icon: <GraduationCap size={48} />,
      title: 'Education & Technology',
      description: 'Empowering career discovery and skills development through AI-driven assessments and personalized learning paths.'
    }
  ];

  return (
    <section id="industries" style={{
      background: 'var(--bg-primary)',
      padding: '100px 7.6923%',
      position: 'relative'
    }}>
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto'
      }}>
        {/* Section Header */}
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <div style={{
            display: 'inline-block',
            padding: '8px 16px',
            background: 'rgba(0, 255, 209, 0.1)',
            border: '1px solid var(--brand-primary)',
            marginBottom: '20px',
            fontSize: '14px',
            color: 'var(--brand-primary)',
            fontWeight: '500'
          }}>
            INDUSTRIES WE SERVE
          </div>
          <h2 className="display-large" style={{ marginBottom: '20px' }}>
            Transforming <span style={{ color: 'var(--brand-primary)' }}>Industries</span> Through Technology
          </h2>
          <p className="body-medium" style={{ maxWidth: '800px', margin: '0 auto' }}>
            Our innovative solutions address specific challenges across diverse sectors, driving operational excellence and sustainable growth.
          </p>
        </div>

        {/* Industries Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '40px'
        }}>
          {industries.map((industry, index) => (
            <div key={index} style={{
              padding: '50px 40px',
              background: 'rgba(255, 255, 255, 0.03)',
              border: '1px solid var(--border-subtle)',
              transition: 'all 0.4s ease-in-out',
              position: 'relative',
              overflow: 'hidden'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = 'var(--brand-primary)';
              e.currentTarget.style.transform = 'translateY(-10px)';
              e.currentTarget.style.background = 'rgba(0, 255, 209, 0.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = 'var(--border-subtle)';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.03)';
            }}
            >
              <div style={{
                color: 'var(--brand-primary)',
                marginBottom: '24px',
                transition: 'transform 0.4s ease-in-out'
              }}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                {industry.icon}
              </div>
              <h3 className="heading-2" style={{ marginBottom: '16px' }}>
                {industry.title}
              </h3>
              <p className="body-small">
                {industry.description}
              </p>
              
              {/* Decorative element */}
              <div style={{
                position: 'absolute',
                bottom: '-20px',
                right: '-20px',
                width: '100px',
                height: '100px',
                background: 'var(--brand-primary)',
                opacity: '0.03',
                borderRadius: '50%'
              }} />
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div style={{
          marginTop: '80px',
          textAlign: 'center',
          padding: '60px',
          background: 'rgba(255, 255, 255, 0.03)',
          border: '1px solid var(--border-subtle)'
        }}>
          <h3 className="heading-1" style={{ marginBottom: '20px' }}>
            Don't See Your Industry?
          </h3>
          <p className="body-medium" style={{ marginBottom: '30px', maxWidth: '600px', margin: '0 auto 30px' }}>
            We're constantly expanding our expertise. Let's discuss how our innovative solutions can transform your business.
          </p>
          <button className="btn-primary" onClick={() => {
            const element = document.getElementById('contact');
            if (element) element.scrollIntoView({ behavior: 'smooth' });
          }}>
            Get in Touch
          </button>
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;